import React, { FC } from 'react';
import { useMutation } from 'react-query';
import { APIKeysApi } from 'api/api-keys';
import { Menu } from 'components/atoms/dropdown';
import { MoreActionsDropdown } from 'components/atoms/more-actions';
import { toastService } from 'components/molecules/toast';
import { useDeleteConfirmModal } from 'hooks/use-delete-confirm-modal';
import { useTranslate } from 'hooks/use-translation';
import { queryClient } from 'queries';
import { GET_RL_KEY } from 'queries/api-keys';

export const MoreOptionsRenderer: FC<{ apiKeyId: number; apiKeyName: string }> =
  ({ apiKeyId, apiKeyName }) => {
    const { deleteRLApiKey } = APIKeysApi;
    const deleteFunction = (id: number) => deleteRLApiKey(id);
    const translate = useTranslate();

    const { mutate: deleteApiKey } = useMutation(
      (id: number) => deleteFunction(id),
      {
        onSuccess: async () => {
          await queryClient.refetchQueries(GET_RL_KEY);
          toastService({
            title: translate('settings.api.api_key_deleted'),
            message: (
              <p>{translate('settings.api.api_key_deleted_description')}</p>
            ),
            duration: 5,
          }).success();
        },
      },
    );

    const deleteModalTitle = translate(
      'settings.api.delete_api_key.modal.title',
    );
    const deleteModalContent1 = translate(
      'settings.api.delete_api_key.modal.description1',
    );
    const deleteModalContent2 = translate(
      'settings.api.delete_api_key.modal.description2',
      {
        apiKeyName,
        b: (chunks) => <b>{chunks}</b>,
      },
    );

    const deleteModalHook = useDeleteConfirmModal({
      title: deleteModalTitle,
      content: (
        <p>
          {deleteModalContent1}
          <br />
          <br />
          {deleteModalContent2}
        </p>
      ),
      onOk: () => deleteApiKey(apiKeyId),
    });

    return (
      <MoreActionsDropdown
        className="more-actions"
        placement="bottomLeft"
        menu={
          <Menu>
            <Menu.ItemDelete
              key="delete"
              onClick={() => {
                deleteModalHook();
              }}
            />
          </Menu>
        }
      />
    );
  };
